export type AnalysisListType = keyof typeof ANALYSIS_TAB_LABELS

export const ANALYSIS_TAB_LABELS: Record<string, string> = {
  all: "All",
  favorites: "Favorites",
}
